import { isErrorPage, isMaintenancePage } from '../utils/url'

export const useErrorPages = ({ pathname }) => {
	const isError = isErrorPage(pathname)
	const isNotFound = pathname === '/404'
	const isMaintenance = isMaintenancePage(pathname)

	return { isError, isNotFound, isMaintenance }
}
